import dynamicClass from 'clsx';
import './payment-stepper.scss';

const PaymentStepper = ({ itemList, currentIndex, title, subtitle, titleType, isTwo }: any) => {
  const classStepperItem = (index) => {
    return dynamicClass('m-payment-stepper__item', {
      '--past': currentIndex > index,
      __active: currentIndex === index,
      '--pre-past': index === 1 && currentIndex === 0.9,
    });
  };

  const classProgressBar = dynamicClass('m-payment-stepper__progress-bar-wrapper', {
    '--first': currentIndex === 0,
    '--medium': currentIndex === 1 || isTwo,
    '--next': currentIndex === 0.9,
    '--last': currentIndex === 2,
    '--two': !!isTwo,
    'two--left': isTwo,
  });

  const classStepperContent = dynamicClass('m-payment-stepper__content', {
    'stepper-two': !!isTwo,
  });

  const classStepperItemName = dynamicClass('m-payment-stepper__item-name', {
    '--two': !!isTwo,
  });

  const classStepper = dynamicClass('m-payment-stepper', {
    '--two': !!isTwo,
  });

  return (
    <div className={classStepper}>
      {title && subtitle && (
        <div className="m-payment-stepper__headings">
          {titleType === 'h1' ? (
            <>
              <h1 className="m-payment-stepper__headings__title">{title}</h1>
              <h2 className="m-payment-stepper__headings__sub-title">{subtitle}</h2>
            </>
          ) : (
            <>
              <h2 className="m-payment-stepper__headings__title">{title}</h2>
              <h3 className="m-payment-stepper__headings__sub-title">{subtitle}</h3>
            </>
          )}
        </div>
      )}
      <div className={classStepperContent}>
        {itemList.map((info, index) => {
          return (
            <div className={classStepperItem(index)} key={`m-payment-stepper__item${index}`}>
              <div className="m-payment-stepper__item-number">
                <span>{index + 1}</span>
              </div>
              <span className={classStepperItemName}>{info}</span>
            </div>
          );
        })}
        <div className={classProgressBar}>
          <div className="m-payment-stepper__progress-bar" />
        </div>
      </div>
    </div>
  );
};

export default PaymentStepper;
